import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import EventsPage from './pages/EventsPage';
import EventDetailsPage from './pages/EventDetailsPage';
import ShortEventLinkPage from './pages/ShortEventLinkPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import RegisterPage from './pages/RegisterPage';
import CategoriesPage from './pages/CategoriesPage';
import AboutPage from './pages/AboutPage';
import HelpCenterPage from './pages/HelpCenterPage';
import ContactUsPage from './pages/ContactUsPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import DashboardPage from './pages/DashboardPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import TestPage from './pages/TestPage';
import CheckoutPage from './pages/CheckoutPage';
import TicketPage from './pages/TicketPage';
// Admin pages
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import UsersPage from './pages/admin/UsersPage';
import EventsPageAdmin from './pages/admin/EventsPage';
import EditEventPage from './pages/admin/EditEventPage';
import CreateEventPage from './pages/admin/CreateEventPage';
import SalesPage from './pages/admin/SalesPage';
import FailedCheckoutsPage from './pages/admin/FailedCheckoutsPage';
import GateStaffPage from './pages/admin/GateStaffPage';
import OrganizerTeamPage from './pages/admin/OrganizerTeamPage';
import AdminCategoriesPage from './pages/admin/CategoriesPage';
import AdminPaymentsPage from './pages/admin/PaymentsPage';
import AdminSettingsPage from './pages/admin/SettingsPage';
import FamilyBankIpnPage from './pages/admin/FamilyBankIpnPage';
import ProtectedRoute from './components/ProtectedRoute';
import ContactUsFab from './components/support/ContactUsFab';
import SupportEmailWidget from './components/support/SupportEmailWidget';
import ScrollToTop from './components/layout/ScrollToTop';
import { useLocation } from 'react-router-dom';

function AppContent() {
  const location = useLocation();
  const hideWhatsApp = location.pathname.startsWith('/admin');
  const hideSupportWidgets = hideWhatsApp;

  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/test" element={<TestPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetailsPage />} />
        <Route path="/e/:code" element={<ShortEventLinkPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/help" element={<HelpCenterPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/payment-success" element={<PaymentSuccessPage />} />
        <Route path="/mpesa-payment" element={<Navigate to="/events" replace />} />
        <Route path="/mpesa-credentials" element={<Navigate to="/admin/settings" replace />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/:paymentId" element={<CheckoutPage />} />
        <Route path="/purchase" element={<CheckoutPage />} />
        <Route path="/payment/:paymentId" element={<CheckoutPage />} />
        <Route path="/tickets/:ticketId" element={<TicketPage />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute requireAdmin={true}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events"
          element={
            <ProtectedRoute requireStaff={true}>
              <EventsPageAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/:id/edit"
          element={
            <ProtectedRoute requireStaff={true}>
              <EditEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/create"
          element={
            <ProtectedRoute requireStaff={true}>
              <CreateEventPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events/:eventId/gate-staff"
          element={
            <ProtectedRoute requireStaff={true}>
              <GateStaffPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sales"
          element={
            <ProtectedRoute requireStaff={true}>
              <SalesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/team"
          element={
            <ProtectedRoute requireStaff={true}>
              <OrganizerTeamPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/follow-ups"
          element={
            <ProtectedRoute requireStaff={true}>
              <FailedCheckoutsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/categories"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminCategoriesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/venues"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/payments"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminPaymentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/family-bank-ipn"
          element={
            <ProtectedRoute requireSuperAdmin={true}>
              <FamilyBankIpnPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute requireAdmin={true}>
              <AdminSettingsPage />
            </ProtectedRoute>
          }
        />
      </Routes>
      {!hideSupportWidgets && (
        <>
          <ContactUsFab />
          <SupportEmailWidget />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AppContent />
    </div>
  );
}

export default App;